'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { MODAL_TYPES } from 'DesignData/enums/FinderActionModalTypes';
import { connect } from 'react-redux';
import { getRawAsset } from 'DesignData/selectors/rawAssetBuffers';
import { pick } from 'underscore';
import { fetch } from 'DesignData/actions/RawAssetBuffers';
import { RAW_ASSET } from 'DesignData/enums/FolderAssetTypes';
import { getPortalId } from 'DesignData/selectors/auth';
const FileInfoModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/FileInfoModal'));

const _RawAssetModals = ({
  created,
  updated,
  size,
  extension,
  path,
  label,
  closeActionModal,
  modal,
  width,
  height,
  assetId,
  id,
  fetchRawAsset,
  portalId
}) => {
  const lazyLoadAsset = () => {
    if (assetId && !id) {
      fetchRawAsset(assetId);
    }
  };

  const renderShowInformationModal = () => {
    return /*#__PURE__*/_jsx(FileInfoModal, {
      callback: closeActionModal,
      created: created,
      updated: updated,
      size: size,
      extension: extension,
      path: path,
      name: label,
      width: width,
      height: height,
      onModalOpen: lazyLoadAsset,
      id: id,
      fileType: RAW_ASSET,
      portalId: portalId
    }, "FileInfoModal");
  };

  switch (modal) {
    case MODAL_TYPES.SHOW_INFORMATION:
      return renderShowInformationModal();

    default:
      return null;
  }
};

const RawAssetModals = connect((state, props) => Object.assign({}, pick(getRawAsset(state, props), 'created', 'updated', 'size', 'extension', 'path', 'label', 'width', 'height', 'id'), {
  portalId: getPortalId(state)
}), {
  fetchRawAsset: fetch
})(_RawAssetModals);
RawAssetModals.propTypes = {
  closeActionModal: PropTypes.func.isRequired,
  assetId: FilePropTypes.fileId,
  modal: PropTypes.oneOf(Object.keys(MODAL_TYPES))
};
export default RawAssetModals;